<template>
  <div class="add-goods">
    <el-form
      :model="goodsForm"
      :rules="goodsRules"
      ref="goodsForm"
      class="demo-goodsForm"
      label-position="left"
    >
      <el-form-item label="商品分类" required>
        <div class="type">
          <el-form-item prop="goodsTypeOne">
            <el-select
              style="margin-right: 12px"
              v-model="goodsForm.goodsTypeOne"
              placeholder="请选择一级分类"
              @change="changeTypeOne"
            >
              <el-option
                v-for="item in firstList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="goodsTypeTwo">
            <el-select
              v-model="goodsForm.goodsTypeTwo"
              placeholder="请选择二级分类"
            >
              <el-option
                v-for="item in secondList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form-item>
      <el-form-item label="商品标题" prop="name">
        <el-input
          v-model="goodsForm.name"
          show-word-limit
          maxlength="40"
          placeholder="请输入商品标题"
          class="text-input"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品副标题">
        <el-input
          v-model="goodsForm.sketch"
          show-word-limit
          maxlength="40"
          placeholder="请输入商品副标题"
          class="text-input"
        ></el-input>
      </el-form-item>
      <el-form-item label="显示金额" prop="showMoney">
        <el-input
          v-model="goodsForm.showMoney"
          type="number"
          placeholder="请输入显示金额"
          class="text-input"
        ></el-input>
      </el-form-item>
      <el-form-item label="划线金额">
        <el-input
          v-model="goodsForm.underlineMoney"
          type="number"
          placeholder="请输入划线金额"
          class="text-input"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品标签">
        <el-tag
          :key="tag"
          class="tag"
          v-for="tag in GoodsTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
        >
          {{ tag }}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput"
          >+</el-button
        >
      </el-form-item>
      <el-form-item label="是否包邮" prop="postageType">
        <el-radio-group v-model="goodsForm.postageType">
          <el-radio
            v-for="item in getDictDatas(DICT_TYPE.POSTAGE_TYPE)"
            :key="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="邮费" prop="postage">
        <el-input
          v-model="goodsForm.postage"
          type="number"
          placeholder="请输入邮费"
          class="number-input"
        ></el-input>
      </el-form-item>
      <el-form-item label="销量" prop="salesVolume">
        <el-input
          v-model="goodsForm.salesVolume"
          placeholder="请输入销量"
          class="number-input"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品封面" prop="goodscover">
        <upload-img
          :fixedNumber="[20, 20]"
          fixedName="1:1"
          accept="image/*"
          tip="推荐图片尺寸宽高比1:1"
          uploadName="上传封面"
          @uploadInfo="uploadInfo"
          :fixedFlag="true"
          :resultImg="goodsForm.goodscover"
        />
      </el-form-item>
      <el-form-item label="商品主图" required>
        <multi-upload
          @avatarFile="avatarFile"
          @removeFile="removeFile"
          :list="mainImage"
        />
      </el-form-item>
      <el-form-item label="商品详情页" required>
        <multi-upload
          @avatarFile="detailsFile"
          @removeFile="removeDetailsFile"
          :list="detailsList"
        />
      </el-form-item>
      <div class="list-scrollbar">
        <el-form-item label="商品规格" required>
          <div class="add-rhythm" @click="addSku">
            <img src="../../../assets/add.png" alt="" /> 添加数据
          </div>
          <div class="rhythm-box">
            <el-row class="title-row">
              <el-col :span="6">规格名称</el-col>
              <el-col :span="6">封面</el-col>
              <el-col :span="6">价格及库存</el-col>
              <el-col :span="4">规格上架状态</el-col>
              <el-col :span="2"> </el-col>
            </el-row>
            <el-row
              v-for="(item, index) in goodsForm.skuList"
              :key="index"
              class="item-box"
            >
              <el-col :span="6">
                <el-form-item
                  :prop="'skuList.' + index + '.skuName'"
                  :rules="goodsRules.skuName"
                >
                  <el-input
                    v-model="item.skuName"
                    placeholder="请输入规格名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :prop="'skuList.' + index + '.cover'"
                  :rules="goodsRules.cover"
                >
                  <upload-img
                    :fixedNumber="[20, 20]"
                    fixedName="1:1"
                    accept="image/*"
                    uploadName="上传规格图片"
                    tip="目前只支持一个规格添加一张图片，图片比例1:1"
                    @uploadInfo="(event) => uploadSkuInfo(event, index)"
                    :fixedFlag="true"
                    :resultImg="item.cover"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :prop="'skuList.' + index + '.money'"
                  :rules="goodsRules.money"
                  style="margin-right: 8px"
                >
                  <el-input
                    v-model="item.money"
                    placeholder="显示价格"
                    type="number"
                    min="0"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :prop="'skuList.' + index + '.stock'"
                  :rules="goodsRules.stock"
                >
                  <el-input
                    v-model="item.stock"
                    placeholder="库存数量"
                    type="number"
                    min="0"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :prop="'skuList.' + index + '.isListed'">
                  <el-switch
                    v-model="item.isListed"
                    :active-value="0"
                    :inactive-value="1"
                  ></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <!-- <span @click="deleteSku(index)">删除</span> -->
                <i class="el-icon-delete" @click="deleteSku(index)"></i>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </div>
      <el-form-item label="是否上架">
        <el-switch
          v-model="goodsForm.isListed"
          :active-value="0"
          :inactive-value="1"
        ></el-switch>
      </el-form-item>
      <el-form-item class="handlebox">
        <el-button
          type="primary"
          @click="submitForm('goodsForm')"
          class="enter-btn save-btn"
          :loading="submitLoading"
          >确认{{ type === "add" ? "添加" : "修改" }}</el-button
        >
        <el-button
          @click="resetForm('goodsForm')"
          class="cancel-btn calloff-btn"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import UploadImg from "../../../components/UploadImg";
import MultiUpload from "../../../components/MultiUpload";
import { getClassifyList, setGoods, getGoodsDetails } from "@/api/shop";
import { uploadOss } from "@/api/login";
export default {
  components: { UploadImg, MultiUpload },
  data() {
    return {
      goodsForm: {
        goodsTypeOne: "",
        goodsTypeTwo: "",
        name: "",
        sketch: "",
        showMoney: "",
        goodscover: "",
        underlineMoney: "",
        postageType: "",
        postage: 0,
        salesVolume: "",
        skuList: [
          {
            cover: "",
            money: "",
            skuName: "",
            stock: "",
            isListed: 0,
          },
        ],
        isListed: 0,
      },
      mainImage: [],
      detailsList: [],
      goodsRules: {
        goodsTypeOne: [
          { required: true, message: "请选择商品一级分类", trigger: "change" },
        ],
        goodsTypeTwo: [
          { required: true, message: "请选择商品二级分类", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入商品标题", trigger: "blur" }],
        showMoney: [
          { required: true, message: "请输入商品显示金额", trigger: "blur" },
        ],
        postageType: [
          { required: true, message: "请选择邮费计费方式", trigger: "change" },
        ],
        postage: [{ required: true, message: "请输入邮费", trigger: "blur" }],
        salesVolume: [
          { required: true, message: "请输入商品销量", trigger: "blur" },
        ],
        goodscover: [
          { required: true, message: "请上传商品封面", trigger: "change" },
        ],
        cover: [
          { required: true, message: "请上传规格图片", trigger: "change" },
        ],
        money: [{ required: true, message: "请输入规格价格", trigger: "blur" }],
        skuName: [
          { required: true, message: "请输入规格名称", trigger: "blur" },
        ],
        stock: [{ required: true, message: "请输入库存数量", trigger: "blur" }],
      },
      submitLoading: false,
      firstList: [],
      secondList: [],
      GoodsTags: [],
      inputVisible: false,
      inputValue: "",
      id: "",
      type: "add",
    };
  },
  async created() {
    const res = await getClassifyList({});
    this.firstList = res.result;
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    if (this.type === "edit") {
      const res = await getGoodsDetails({ id: this.id });
      const res1 = await getClassifyList({ parentId: res.result.goodsTypeOne });
      this.goodsForm = res.result;
      this.goodsForm.goodscover = res.result.cover;
      this.secondList = res1.result;
      this.GoodsTags = this.goodsForm.label.split(",");
      this.detailsList = this.goodsForm.details.split(",").map((el) => {
        return {
          name: el.split("/")[el.split("/").length - 1],
          url: el,
        };
      });
      this.mainImage = this.goodsForm.goodsImg.split(",").map((el) => {
        return {
          name: el.split("/")[el.split("/").length - 1],
          url: el,
        };
      });
    }
  },
  mounted() {},
  methods: {
    // 获取上传封面
    uploadInfo(info) {
      this.goodsForm.goodscover = info;
    },
    // 上传主图
    avatarFile(file, fileList) {
      // this.imgFile = file;
      console.log("file,fileList :>> ", file, fileList);
      this.mainImage = fileList;
    },
    removeFile(file, fileList) {
      this.mainImage = fileList;
      console.log(this.mainImage);
    },
    // 上传详情
    detailsFile(file, fileList) {
      this.detailsList = fileList;
      console.log("file,fileList :>> ", file, fileList, this.detailsList);
    },
    removeDetailsFile(file, fileList) {
      this.detailsList = fileList;
      console.log("file,fileList :>> ", file, fileList, this.detailsList);
    },
    // sku封面
    uploadSkuInfo(info, index) {
      // console.log(info, index);
      this.goodsForm.skuList[index].cover = info;
    },
    // 添加sku
    addSku() {
      this.goodsForm.skuList.push({
        cover: "",
        money: "",
        skuName: "",
        stock: "",
        isListed: 0,
      });
    },
    // 删除sku
    deleteSku(index) {
      if (this.goodsForm.skuList.length === 1) {
        return;
      }
      this.goodsForm.skuList.splice(index, 1);
    },
    async changeTypeOne(value) {
      // console.log("value :>> ", value);
      this.goodsForm.goodsTypeTwo = "";
      const res = await getClassifyList({ parentId: value });
      this.secondList = res.result;
    },
    // 新建商品
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.mainImage.length === 0) {
            this.$message.error("请上传商品主图");
            return;
          }
          if (this.detailsList.length === 0) {
            this.$message.error("请上传商品详情页");
            return;
          }
          this.submitLoading = true;
          let mainImageArr = [];
          for (let i = 0; i < this.mainImage.length; i++) {
            let promise = new Promise((resolve, reject) => {
              if (!this.mainImage[i].raw) {
                resolve(this.mainImage[i].url);
                return;
              }
              let formData = new FormData();
              let file = this.mainImage[i].raw;
              formData.append("file", file);
              formData.append("fileDir", "goodsImg");
              uploadOss(formData).then((res) => {
                // console.log(res);
                if (res.code === 200) {
                  resolve(res.result);
                  return;
                }
                reject(res.result);
              });
            });
            mainImageArr.push(promise);
          }
          const mainImage = await Promise.all(mainImageArr);
          // console.log(mainImage);
          let detailsArr = [];
          for (let i = 0; i < this.detailsList.length; i++) {
            let promise = new Promise((resolve, reject) => {
              // console.log(this.detailsList[i].row);
              if (!this.detailsList[i].raw) {
                resolve(this.detailsList[i].url);
                return;
              }
              let formData = new FormData();
              let file = this.detailsList[i].raw;
              formData.append("file", file);
              formData.append("fileDir", "goodsImg");
              uploadOss(formData).then((res) => {
                // console.log(res);
                if (res.code === 200) {
                  resolve(res.result);
                  return;
                }
                reject(res.result);
              });
            });
            detailsArr.push(promise);
          }
          const details = await Promise.all(detailsArr);
          let params = {
            ...this.goodsForm,
            details: details.join(","),
            goodsImg: mainImage.join(","),
            label: this.GoodsTags.join(","),
            cover: this.goodsForm.goodscover,
          };
          await setGoods(params);
          this.$message.success("添加成功！");
          this.$router.go(-1);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      // this.$refs[formName].resetFields();
      this.$router.go(-1);
    },
    handleClose(tag) {
      this.GoodsTags.splice(this.GoodsTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.GoodsTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.add-goods {
  .text-input {
    width: 444px;
  }
  .number-input {
    width: 216px;
  }
  ::v-deep .list-scrollbar {
    .rhythm-box {
      // display: flex;
      margin-left: 100px;
      margin-top: 16px;
      // width: 60vw;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
    }
    .add-rhythm {
      padding: 10px 20px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: #ff5d2f;
      line-height: 22px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      cursor: pointer;
      width: fit-content;
      img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }
    }
    .el-form-item__error {
      // white-space: nowrap;
      padding: 0;
    }
    .title-row {
      background: #fafafa;
      border-radius: 4px;
      height: 52px;
      .el-col {
        text-align: center;
        height: 52px;
        font-weight: 400;
        font-size: 14px;
        color: #262626;
        line-height: 20px;
        line-height: 52px;
      }
    }
    .item-box {
      padding: 16px 0;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.02);
      // justify-content: center;
      .el-col {
        display: flex;
        align-items: center;
        justify-content: center;
        .el-input {
          // width: 140px;
          text-align: center;
          .el-input__inner {
            text-align: center;
            height: 32px;
            line-height: 32px;
          }
        }
      }
      .el-col-2 {
        i {
          font-size: 16px;
          color: #ee3a3a;
          line-height: 21px;
          cursor: pointer;
        }
      }
    }
    .item-box:last-child {
      border: none;
    }
  }
  ::v-deep .demo-goodsForm {
    .el-upload {
      background: none;
    }
    .result-img {
      flex-direction: column;
      img {
        margin: 0;
      }
      .el-button {
        margin-top: 10px;
      }
    }
    .el-form-item__label {
      white-space: nowrap;
      min-width: 100px;
    }
    .type {
      display: flex;
      align-items: center;
    }
    .tag {
      margin-right: 8px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      .el-tag__close {
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .input-new-tag {
      width: 100px;
    }
    .button-new-tag {
      padding: 6px 12px;
      background: rgba(0, 0, 0, 0.02);
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      color: #000000;
      line-height: 1;
      font-size: 16px;
    }
    .handlebox {
      margin: 50px 0 0 100px;
    }
    .el-radio {
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      .el-radio__label {
        color: rgba(0, 0, 0, 0.85);
      }
      .el-radio__inner {
        width: 16px;
        height: 16px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #d9d9d9;
      }
      .is-checked {
        .el-radio__inner {
          border: 1px solid #ff5d2f;
        }
        .el-radio__inner::after {
          width: 8px;
          height: 8px;
          background: #ff5d2f;
        }
      }
    }
    input[aria-hidden="true"] {
      display: none !important;
    }

    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
      .el-radio__inner {
      box-shadow: none !important;
    }
  }
}
</style>
